<template>
  <div class="single-exam-detail">
    <pageTitle :pageTitle="overHidden(examData.title, 30)">
      <vh-tooltip class="item" effect="dark" placement="right">
        <i class="iconfont-v3 saasicon_help_m" />
        <div slot="content">
          <p>{{ $t('lang.k_191001') }}</p>
          <p>{{ $t('lang.k_191002') }}</p>
        </div>
      </vh-tooltip>
    </pageTitle>
    <!-- 上半部分区间 -->
    <div class="single-exam-detail__header">
      <!-- <p class="exam-webinar-title">{{ examData.title }}</p> -->
      <div class="single-exam-detail__data">
        <vh-row type="flex" class="row-bg" justify="space-around">
          <vh-col :span="7">
            <div class="grid-content">
              <span>{{ $t('lang.k_191003') }}</span>
              <vh-tooltip effect="dark" placement="right" v-tooltipMove>
                <div slot="content">{{ $t('lang.k_191004') }}</div>
                <i class="iconfont-v3 saasicon_help_m"></i>
              </vh-tooltip>
              <h3 class="custom-font-barlow">
                <count-to
                  :startVal="0"
                  :endVal="examData.un_answered_num || 0"
                  :duration="1500"
                  class="font-set"
                ></count-to>
              </h3>
            </div>
          </vh-col>
          <vh-col :span="7">
            <div class="grid-content">
              <span>{{ $t('lang.k_191005') }}</span>
              <vh-tooltip effect="dark" placement="right" v-tooltipMove>
                <div slot="content">{{ $t('lang.k_191006') }}</div>
                <i class="iconfont-v3 saasicon_help_m"></i>
              </vh-tooltip>
              <h3 class="custom-font-barlow">
                <count-to
                  :startVal="0"
                  :endVal="examData.answer_num"
                  :duration="1500"
                  v-if="examData.answer_num >= 0"
                  class="font-set"
                ></count-to>
              </h3>
            </div>
          </vh-col>
          <vh-col :span="10">
            <div class="grid-content">
              <span>{{ $t('lang.k_191007') }}</span>
              <vh-tooltip effect="dark" placement="right" v-tooltipMove>
                <div slot="content">{{ $t('lang.k_191008') }}</div>
                <i class="iconfont-v3 saasicon_help_m"></i>
              </vh-tooltip>
              <h3 class="custom-font-barlow">
                {{ roundRate(examData.full_score_rate) }}%，
                <count-to
                  :startVal="0"
                  :endVal="examData.full_score_num"
                  :duration="1500"
                  class="font-set"
                ></count-to>
                {{ $t('lang.k_191009') }}
              </h3>
            </div>
          </vh-col>
        </vh-row>
        <vh-row type="flex" class="row-bg" justify="space-around">
          <vh-col :span="7">
            <div class="grid-content">
              <span>{{ $t('lang.k_191010') }}</span>
              <h3 class="custom-font-barlow">
                {{ examData.max_score || 0 }}
              </h3>
            </div>
          </vh-col>
          <vh-col :span="7">
            <div class="grid-content">
              <span>{{ $t('lang.k_191011') }}</span>
              <h3 class="custom-font-barlow">
                {{ examData.min_score }}
              </h3>
            </div>
          </vh-col>
          <vh-col :span="10">
            <div class="grid-content">
              <span>{{ $t('lang.k_191012') }}</span>
              <vh-tooltip effect="dark" placement="right" v-tooltipMove>
                <div slot="content">{{ $t('lang.k_191013') }}</div>
                <i class="iconfont-v3 saasicon_help_m"></i>
              </vh-tooltip>
              <h3 class="custom-font-barlow">
                {{ roundRate(examData.avg_score) }}
              </h3>
            </div>
          </vh-col>
        </vh-row>
      </div>
    </div>

    <!-- 下半部分区间 -->
    <div class="single-exam-detail__list">
      <div class="all-yes-data">
        <vh-tabs v-model="activeName" @tab-click="handleClick">
          <vh-tab-pane name="scoreRank">
            <span slot="label">
              {{ $t('lang.k_191014') }}
              <vh-tooltip v-tooltipMove :visible-arrow="false" placement="right-start">
                <div slot="content">
                  <p>{{ $t('lang.k_191015') }}</p>
                  <p></p>
                  <p>{{ $t('lang.k_191016') }}</p>
                  <p>{{ $t('lang.k_191017') }}</p>
                  <p>{{ $t('lang.k_191018') }}</p>
                  <p>{{ $t('lang.k_191019') }}</p>
                  <p>{{ $t('lang.k_191020') }}</p>
                  <p>{{ $t('lang.k_191021') }}</p>
                </div>
                <i class="iconfont-v3 saasicon_help_m tip"></i>
              </vh-tooltip>
            </span>

            <div class="list--search">
              <div>
                <vh-input
                  :placeholder="$t('lang.k_191022')"
                  v-model="query.user_name"
                  clearable
                  round
                  @clear="initQueryList"
                  class="search-query"
                  v-clearEmoij
                  @keyup.enter.native="initQueryList"
                >
                  <i class="vh-icon-search vh-input__icon" slot="prefix" @click="initQueryList"></i>
                </vh-input>
                <vh-select
                  :placeholder="$t('lang.k_191023')"
                  round
                  v-model="query.status"
                  @change="initQueryList"
                >
                  <vh-option value="">{{ $t('lang.k_191023') }}</vh-option>
                  <vh-option
                    v-for="item in statusOptions"
                    :key="'data_' + item.label"
                    :label="item.label"
                    :value="item.value"
                  ></vh-option>
                </vh-select>
              </div>
              <vh-button type="info" ghost @click="downloadHandle('all')" borderRadius="50">
                {{ $t('lang.k_191024') }}
              </vh-button>
            </div>
            <div class="tab-content">
              <vh-table
                ref="tableList"
                :data="resultVo.list"
                tooltip-effect="dark"
                style="width: 100%"
                :header-cell-style="{ background: '#f7f7f7', color: '#666', height: '56px' }"
              >
                <vh-table-column
                  align="left"
                  v-for="(item, index) in tableColumns"
                  :key="index"
                  :width="item.width"
                  :label="item.label"
                  :show-overflow-tooltip="item.customTooltip"
                  :min-width="item.minWidth"
                >
                  <template slot-scope="scope">
                    <div class="icon-status" v-if="item.key === 'is_initiative'">
                      {{ scope.row.is_initiative == 1 ? $t('lang.k_191025') : $t('lang.k_191026') }}
                    </div>
                    <div class="icon-status" v-else-if="item.key === 'use_time'">
                      {{ scope.row.use_time | fmtUseTime }}
                      <!-- 转换时间 -->
                    </div>
                    <div class="icon-status" v-else-if="item.key === 'rank_no'">
                      {{ scope.row.status ? scope.row.rank_no : '-' }}
                      <!-- 配合头像 -->
                    </div>
                    <div class="icon-status" v-else-if="item.key === 'score'">
                      {{ scope.row.total_score ? scope.row.score : '-' }}
                      <!-- 配合头像 -->
                    </div>
                    <div class="icon-status" v-else-if="item.key === 'right_rate'">
                      {{ roundRate(scope.row.right_rate) }}%
                      <!-- 配合头像 -->
                    </div>
                    <span v-else>{{ scope.row[item.key] || '-' }}</span>
                  </template>
                </vh-table-column>
                <vh-table-column
                  :label="$t('lang.k_191027')"
                  align="left"
                  class="btn-rows"
                  fixed="right"
                  width="160"
                >
                  <template slot-scope="scope">
                    <vh-button
                      borderRadius="4"
                      type="text"
                      size="mini"
                      @click="openScoreDialog(scope.row)"
                    >
                      {{ $t('lang.k_191028') }}
                    </vh-button>
                    <vh-button
                      borderRadius="4"
                      type="text"
                      size="mini"
                      @click="editDataStatus(scope.row, false)"
                      v-if="scope.row.status > 0"
                    >
                      {{ $t('lang.k_191029') }}
                    </vh-button>
                    <vh-button
                      borderRadius="4"
                      type="text"
                      plain
                      size="mini"
                      @click="editDataStatus(scope.row, true)"
                      v-else
                    >
                      {{ $t('lang.k_191030') }}
                    </vh-button>
                  </template>
                </vh-table-column>
                <div slot="empty"></div>
              </vh-table>
              <null-page
                :nullType="'nullData'"
                :height="52"
                v-if="resultVo.total <= 0"
                :text="nonInfo"
              ></null-page>
            </div>
            <SPagination
              :total="resultVo.total"
              :currentPage="query.pageNumber"
              :page-size="query.limit"
              @current-change="currentChangeHandler"
              @size-change="sizeChange"
            ></SPagination>
          </vh-tab-pane>
          <vh-tab-pane :label="$t('lang.k_191031')" name="examStatistics">
            <div class="download">
              <vh-button
                type="info"
                size="medium"
                ghost
                @click="downloadHandle('statistics')"
                borderRadius="50"
              >
                {{ $t('lang.k_191032') }}
              </vh-button>
            </div>
            <ExamStatistics :authentication="authentication" :paper-id="paperId" ref="statistics" />
          </vh-tab-pane>
        </vh-tabs>
      </div>
    </div>
    <!-- 个人成绩单 -->
    <transcript ref="transition"></transcript>
  </div>
</template>
<script>
  import NullPage from '@/views/PlatformModule/Error/nullPage';
  import CountTo from 'vue-count-to';
  import Transcript from '@/components/Transcript';
  import examServer from '@/utils/examServer';
  import PageTitle from '@/components/PageTitle';
  import { overHidden, roundRate, embedRoomId } from '@/utils/utils';
  import { ExamStatistics } from '@vhcl/webcasting-quiz';
  export default {
    name: 'ExamPerformanceStatistics',
    components: {
      CountTo,
      NullPage,
      Transcript,
      PageTitle,
      ExamStatistics
    },
    data() {
      return {
        activeName: 'scoreRank',
        vm: null,
        loading: false,
        examData: {
          title: '', // 快问快答名称
          check_num: 0, // 查看人数
          answer_num: 0, // 答题人数
          full_score_rate: 0, // 满分率
          full_score_num: 0, // 总人数
          max_score: 0, // 最高分
          min_score: 0, // 最低分
          avg_score: 0 // 平均分
        },
        query: {
          status: '',
          user_name: '',
          pos: 0,
          limit: 20,
          pageNumber: 1
        },
        resultVo: {
          total: 0,
          list: []
        },
        tableColumns: [
          {
            label: this.$t('lang.k_191033'),
            key: 'rank_no',
            width: 80
          },
          {
            label: this.$t('lang.k_191034'),
            key: 'account_id',
            width: 100
          },
          {
            label: this.$t('lang.k_191035'),
            key: 'user_name',
            minWidth: 120,
            customTooltip: true
          },
          {
            label: this.$t('lang.k_191036'),
            key: 'mobile',
            width: 120,
            customTooltip: true
          },
          {
            label: this.$t('lang.k_191037'),
            key: 'email',
            width: 150,
            customTooltip: true
          },
          {
            label: this.$t('lang.k_191038'),
            key: 'join_time',
            width: 160,
            customTooltip: true
          },
          {
            label: this.$t('lang.k_191039'),
            key: 'score',
            width: 80
          },
          {
            label: this.$t('lang.k_191040'),
            key: 'right_rate',
            width: 90
          },
          {
            label: this.$t('lang.k_191041'),
            key: 'use_time',
            width: 100
          },
          {
            label: this.$t('lang.k_191042'),
            key: 'is_initiative',
            width: 100
          }
        ],

        nonInfo: this.$t('lang.k_191043'),
        authentication: null,
        paperId: this.$route.query.paperId,
        statusOptions: [
          {
            label: this.$t('lang.k_191044'),
            value: 1
          },
          {
            label: this.$t('lang.k_191045'),
            value: 0
          }
        ]
      };
    },
    filters: {
      fmtUseTime(time) {
        time = parseInt(time) || 0;
        const mm = `${Math.floor(time / 60)}`.padStart(2, '0');
        const ss = `${Math.floor(time % 60)}`.padStart(2, '0');
        return `${mm}:${ss}`;
      }
    },
    computed: {
      isNullData() {
        return false;
      }
    },
    mounted() {
      this.initComp();
    },
    methods: {
      // tab切换请求新数据
      handleClick() {
        if (this.activeName === 'examStatistics') {
          this.$refs.statistics.getExamStatistics();
        }
      },
      //文案提示问题
      messageInfo(msg, type) {
        if (this.vm) {
          this.vm.close();
        }
        this.vm = this.$vhMessage({
          showClose: true,
          message: msg,
          type: type,
          customClass: 'zdy-info-box'
        });
      },
      // 查询快问快答 - 统计人数
      getSingleExamData() {
        examServer
          .getExamPaperSummary({
            paper_id: this.$route.query.paperId
          })
          .then(res => {
            this.examData = res.data;
            this.authentication = examServer.examInstance?.initInfo;
          })
          .catch(e => {
            console.log(e);
          });
      },
      // 页码改变按钮事件
      currentChangeHandler(current) {
        this.query.pageNumber = current;
        this.query.pos = parseInt((current - 1) * this.query.limit);
        this.getExamScoreList();
      },
      // 页码改变按钮事件
      sizeChange(current) {
        this.query.pageNumber = 1;
        this.query.limit = current;
        this.query.pos = 0;
        this.getExamScoreList();
      },
      // 查询成绩排名
      getExamScoreList() {
        let params = {
          paper_id: this.$route.query.paperId,
          pos: this.query.pos,
          limit: this.query.limit,
          user_name: this.query.user_name,
          status: this.query.status,
          is_desensitization: 0 // 是否雾化用户名 0.否 1.是
        };
        this.loading = true;
        examServer
          .getExamRankList(this.$params(params))
          .then(res => {
            this.loading = false;
            this.resultVo = res.data;
          })
          .catch(e => {
            this.loading = false;
            this.resultVo = {
              total: 0,
              list: []
            };
          });
      },
      // 查询成绩排名 - 默认
      initQueryList(init) {
        this.query.pos = 0;
        this.query.pageNumber = 1;
        this.query.limit = 10;
        this.getExamScoreList();
        if (init !== 'init') {
          this.nonInfo = this.$t('lang.k_191046');
        }
      },
      // 导出
      downloadHandle(type) {
        const api = {
          all: 'exportExamRank',
          statistics: 'exportExamStatistics'
        };
        this.$fetch(
          api[type],
          this.$params({
            paper_id: this.$route.query.paperId,
            webinar_id: this.$route.params.str
          })
        )
          .then(res => {
            this.$vhMessage({
              message: this.$t('lang.k_191047', [
                this.$store.state.permissionValue.custom_download_toast || this.$t('lang.k_191048')
              ]),

              showClose: true,
              // duration: 0,
              type: 'success',
              customClass: 'zdy-info-box'
            });
            this.$EventBus.$emit('saas_vs_download_change');
          })
          .catch(res => {
            this.$vhMessage({
              message: res.msg || `${this.$t('lang.k_191049')}`,
              showClose: true,
              // duration: 0,
              type: 'error',
              customClass: 'zdy-info-box'
            });
          });
      },
      // 查看成绩
      openScoreDialog(row) {
        this.$refs.transition.open({
          ...row,
          id: this.$route.query.paperId,
          roomId: embedRoomId() || this.$route.query.roomId,
          webinarId: this.$route.params.str
        });
      },
      // 标记无效
      editDataStatus(rows, resultFul = false) {
        const tip = resultFul ? this.$t('lang.k_191050') : this.$t('lang.k_191051');

        this.$vhConfirm(tip, this.$t('lang.k_191052'), {
          confirmButtonText: this.$t('lang.k_191053'),
          cancelButtonText: this.$t('lang.k_191054'),
          roundButton: true,
          roundButton: true,

          closeOnClickModal: false
        })
          .then(() => {
            examServer
              .markExamTranscript({
                paper_id: this.$route.query.paperId,
                account_type: rows.account_type,
                account_id: rows.account_id,
                status: resultFul ? 1 : 0
              })
              .then(res => {
                if (res.code === 200) {
                  this.messageInfo(this.$t('lang.k_191055'), 'success');
                  this.initQueryList();
                } else {
                  this.messageInfo(res.msg || this.$t('lang.k_191056'), 'error');
                }
              })
              .catch(e => {
                this.messageInfo(res.msg || this.$t('lang.k_191056'), 'error');
              });
          })
          .catch(() => {});
      },
      // 表格操作列回调函数， val表示每行
      onHandleBtnClick(val) {
        let methodsCombin = this.$options.methods;
        methodsCombin[val.type](this, val);
      },
      // 界面初始化方法入口
      initComp() {
        this.getSingleExamData();
        this.initQueryList('init');
      },
      overHidden,
      roundRate
    }
  };
</script>
<style lang="less" scoped>
  .single-exam-detail {
    /deep/.saasicon_help_m {
      color: #999999;
      &:hover {
        color: #666666;
      }
    }
    .single-exam-detail__header {
      padding: 24px 32px;
      background: #fff;
      border-radius: 4px;
      .exam-webinar-title {
        font-size: 16px;
        font-weight: 400;
        color: #1a1a1a;
        text-align: left;
        padding: 12px 0 18px 12px;
        border-bottom: 1px solid #eaeaea;
        padding: 4px 0 12px 0;
        margin-bottom: 24px;
      }
      .row-bg {
        margin: 12px 28px 64px 28px;
      }
      .bg-purple {
        margin-bottom: 26px;
      }
      .activeJustify {
        justify-content: space-around;
      }
      .grid-content {
        text-align: left;
        > span {
          font-size: 14px;
          color: #999;
          margin: 0;
        }
        i {
          font-size: 14px;
          padding: 0 2px;
        }
        h3 {
          padding-top: 6px;
          font-size: 28px;
          font-weight: bold;
          color: #1a1a1a;
          span {
            font-size: 28px;
            font-weight: bold;
            color: #1a1a1a;
            margin: 0;
          }
        }
      }
    }
    .single-exam-detail__list {
      margin-top: 24px;
      padding: 10px 12px 40px 12px;
      background: #fff;
      border-radius: 4px;
      min-height: 44vh;

      /deep/.all-yes-data {
        .data-list {
          .vh-table {
            margin-bottom: 40px;
            .cell {
              line-height: 25px;
            }
          }
        }
      }
      .search-no-data {
        padding-top: 148px;
        .search {
          padding-bottom: 0;
        }
      }
      /deep/.list--search {
        margin-bottom: 38px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .vh-select {
          width: 140px;
          margin-right: 20px;
        }
        .search-query {
          width: 260px;
          margin-right: 12px;
        }
      }
      .pageBox {
        margin-top: 32px;
      }
      // 表格
      .vh-table__row {
        /deep/.vh-input-group {
          width: 130px;
        }
      }
      /deep/.vh-table__empty-block {
        min-height: 0;
      }
      /deep/.vh-button--text.zdy-theme-red {
        color: #fb2626;
        &:hover {
          color: #d4151c;
        }
      }
      /deep/.vh-button--text.zdy-theme-gray {
        color: rgba(0, 0, 0, 0.65) !important;
        &:hover {
          color: rgba(0, 0, 0, 0.85) !important;
        }
      }
      .download {
        display: flex;
        flex-direction: row-reverse;
      }
      /deep/ .vh-table__fixed-right::before {
        background-color: transparent;
      }
    }
    .font-set {
      font-family: Barlow;
    }
  }
</style>
